import { Component, EventEmitter, Input } from '@angular/core';
import { isNullOrUndefined } from '@uzurv/core';
import { GenericListIconButtonClickHandlerData } from './generic-list-icon-button-click-handler-data';

@Component({
  selector: 'app-generic-list-icon-button',
  templateUrl: './generic-list-icon-button.component.html',
  styleUrls: ['./generic-list-icon-button.component.scss']
})
export class GenericListIconButtonComponent {
  @Input() testingId = null;
  @Input() buttonColor = 'primary';
  @Input() icon: string;
  @Input() data: any;
  @Input() clickHandler: EventEmitter<GenericListIconButtonClickHandlerData>;
  @Input() disabled = false;

  handleClick(event: MouseEvent) {
    if (!isNullOrUndefined(this.clickHandler)) {
      this.clickHandler.emit({ data: this.data, clickEvent: event });
    }
  }
}
